const HOME_VIEW_ROUTES = {
  '/actors': 'actor',
  '/filmmakers': 'filmmaker',
};

export const getHomeViewType = (pathname) => HOME_VIEW_ROUTES[pathname] || 'epk';
